import client from "./client";
import { API } from "@/constants/httpApi";
import type { CustomEventSource } from "./client";

interface SseService {
  subscribeOtherJudgesAssessments(
    performanceId: string | number,
    type?: string | null
  ): CustomEventSource;
  subscribeMeetingInvitations(judgeId: string | number): CustomEventSource;
  subscribeConfirmationAssessment(
    judgeCode: string,
    performanceId: string | number
  ): CustomEventSource;
}

const sseService: SseService = {
  subscribeOtherJudgesAssessments(performanceId, type = null) {
    const pathType = type ? `/${type}` : "";
    return client.connect(
      `${API.JUDGE_TERMINAL}/performances/${performanceId}/results${pathType}/updates`
    );
  },
  subscribeMeetingInvitations(judgeId) {
    return client.connect(`${API.JUDGE_TERMINAL}/meeting-invitations?judgeId=${judgeId}`);
  },
  subscribeConfirmationAssessment(judgeCode, performanceId) {
    return client.connect(
      `${API.JUDGE_TERMINAL}/performances/${performanceId}/judge-points/${judgeCode}/status`
    );
  },
};

export default sseService;
